
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="InfoOutlineSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#545456" fill-rule="evenodd" d="M13.332 8A5.333 5.333 0 112.665 8a5.333 5.333 0 0110.667 0zm1.333 0A6.667 6.667 0 111.332 8a6.667 6.667 0 0113.333 0zm-7.222 3.334V6.89h1.112v4.444H7.443zm.17-6.689A.694.694 0 118.384 5.8a.694.694 0 01-.771-1.154z" clip-rule="evenodd"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'InfoOutlineSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
